webpackJsonp([1],{

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(644);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


if (window.localStorage.getItem('token')) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
}

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = 'https://mpsolidtec.com.br/be-monitor/public';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

window.axios = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Turnos_vue__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Turnos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Turnos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Maquinas_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Maquinas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Maquinas_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_RelatoriosGerais_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_RelatoriosGerais_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_RelatoriosGerais_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_RelatoriosProducao_vue__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_RelatoriosProducao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_RelatoriosProducao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_RelatoriosProducaoTag_vue__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_RelatoriosProducaoTag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_RelatoriosProducaoTag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_RelatoriosProducaoPedidosTempo_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_RelatoriosProducaoPedidosTempo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_RelatoriosProducaoPedidosTempo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_ImportarProgramacao_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_ImportarProgramacao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_ImportarProgramacao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_OEE_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_OEE_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_OEE_vue__);















var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/logout',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default.a,
    name: 'Disponibilidade',
    meta: {
      description: 'Informações de Disponibilidade',
      requiresAuth: true
    }
  }, {
    path: 'oee',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_OEE_vue___default.a,
    name: 'OEE',
    meta: {
      description: 'Painel OEE',
      requiresAuth: true
    }
  }, {
    path: 'importar',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_ImportarProgramacao_vue___default.a,
    name: 'Importar',
    meta: {
      description: 'Importar Programação',
      requiresAuth: true
    }
  }, {
    path: 'turnos',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Turnos_vue___default.a,
    name: 'Turnos',
    meta: {
      description: 'Período de Produção das Máquinas',
      requiresAuth: true
    }
  }, {
    path: 'maquinas',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Maquinas_vue___default.a,
    name: 'Máquinas',
    meta: {
      description: 'Configuração das Máquinas',
      requiresAuth: true
    }
  }, {
    path: 'relatorios-gerais',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_RelatoriosGerais_vue___default.a,
    name: 'Relatórios Gerais',
    meta: {
      description: 'Visualização concentrada de todos relatórios',
      requiresAuth: true
    }
  }, {
    path: 'relatorios-producao',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_RelatoriosProducao_vue___default.a,
    name: 'Percentual de Operação',
    meta: {
      description: 'Relatório de percentual de tempo em operação por período',
      requiresAuth: true
    }
  }, {
    path: 'relatorios-producao-tag',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_RelatoriosProducaoTag_vue___default.a,
    name: 'Relatório de Produção',
    meta: {
      description: 'Relatório de total produzido por período',
      requiresAuth: true
    }
  }, {
    path: 'relatorios-producao-desempenho',
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_RelatoriosProducaoPedidosTempo_vue___default.a,
    name: 'Relatório de Desempenho',
    meta: {
      description: 'Relatório de desempenho da produção',
      requiresAuth: true
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(145);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: __WEBPACK_IMPORTED_MODULE_5__modules__["default"]
}));

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(594);



var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["a" /* default */].initializeApp({
  apiKey: 'AIzaSyD5U3_YUsJUiV0BVHCm9GYzIOYxLjcvCJU',
  authDomain: 'monitor-de-processos.firebaseapp.com',
  databaseURL: 'https://monitor-de-processos.firebaseio.com',
  projectId: 'monitor-de-processos',
  storageBucket: 'monitor-de-processos.appspot.com',
  messagingSenderId: '75319963636'
}).database();

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_alertify__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_timepicker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_timepicker_dist_VueTimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuefire__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_paginate__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__axios__ = __webpack_require__(413);














__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_6__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_6__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_6__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_6__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(422));


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue2_timepicker___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_alertify__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__["a" /* BootstrapVue */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__["b" /* IconsPlugin */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vuefire__["a" /* rtdbPlugin */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_paginate___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}



new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__components_App_vue___default.a);
  }
});

window.bugsnagClient = window.bugsnag('02fe1c2caaf5874c50b6ee19534f5932');
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]));

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  all: []
};

var mutations = {
  updateControladoresList: function updateControladoresList(state, res) {
    state.all = res.data;
  }
};

var actions = {
  listControladores: function listControladores(context) {
    window.axios.get('/api/v2/controladores').then(function (res) {
      context.commit('updateControladoresList', res);
    });
  },
  updateControlador: function updateControlador(context, data) {
    var id = data.id;
    var qs = __webpack_require__(31);
    var dados = qs.stringify(data.controlador);
    return window.axios.put('/api/v2/controladores/' + id, dados).then(function (res) {
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  all: []
};

var mutations = {
  addLegendasList: function addLegendasList(state, res) {
    state.all.push(res.data);
  },
  updateLegendasList: function updateLegendasList(state, res) {
    state.all = res.data;
  }
};

var actions = {
  createLegenda: function createLegenda(context, data) {
    var qs = __webpack_require__(31);
    data = qs.stringify(data);
    return window.axios.post('/api/v2/legendas', data).then(function (res) {
      context.commit('addLegendasList', res);
      return res;
    });
  },
  updateLegenda: function updateLegenda(context, data) {
    var id = data.id;
    var qs = __webpack_require__(31);
    var dados = qs.stringify(data.legenda);
    return window.axios.put('/api/v2/legendas/' + id, dados).then(function (res) {
      return res;
    });
  },
  deleteLegenda: function deleteLegenda(context, id) {
    return window.axios.delete('/api/v2/legendas/' + id).then(function (res) {
      return res;
    });
  },
  listLegendas: function listLegendas(context, id) {
    return window.axios.get('/api/v2/legendas/controlador/' + id).then(function (res) {
      context.commit('updateLegendasList', res);
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  all: [],
  porControlador: {},
  porTag: {}
};

var mutations = {
  updateMonitoramentosControlador: function updateMonitoramentosControlador(state, res) {
    state.porControlador = res.data;
  },
  updateMonitoramentosControladorTag: function updateMonitoramentosControladorTag(state, res) {
    state.porTag = res.data;
  }
};

var actions = {
  listMonitoramentosControlador: function listMonitoramentosControlador(context, data) {
    window.axios.get('/api/v2/monitoramentos/controlador/' + data).then(function (res) {
      context.commit('updateMonitoramentosControlador', res);
    });
  },
  listMonitoramentosControladorTag: function listMonitoramentosControladorTag(context, data) {
    window.axios.get('/api/v2/monitoramentos/total/tag/controlador/' + data).then(function (res) {
      context.commit('updateMonitoramentosControladorTag', res);
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {};

var mutations = {};

var actions = {
  updateMonitorDia: function updateMonitorDia() {
    window.axios.get('/api/v2/monitores/atualizar');
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  all: []
};

var mutations = {
  addParadasProgramadasList: function addParadasProgramadasList(state, res) {
    state.all.push(res.data);
  },
  clearParadasProgramadasList: function clearParadasProgramadasList(state) {
    state.all = [];
  },
  updateParadasProgramadasList: function updateParadasProgramadasList(state, res) {
    state.all = res.data;
  }
};

var actions = {
  clearListParadasProgramadas: function clearListParadasProgramadas(context, id) {
    context.commit('clearParadasProgramadasList');
  },
  createParadaProgramada: function createParadaProgramada(context, data) {
    var qs = __webpack_require__(31);
    data = qs.stringify(data);
    return window.axios.post('/api/v2/paradasprogramadas', data).then(function (res) {
      context.commit('addParadasProgramadasList', res);
      return res;
    });
  },
  updateParadaProgramada: function updateParadaProgramada(context, data) {
    var id = data.id;
    var qs = __webpack_require__(31);
    var dados = qs.stringify(data.paradaprogramada);
    return window.axios.put('/api/v2/paradasprogramadas/' + id, dados).then(function (res) {
      return res;
    });
  },
  deleteParadaProgramada: function deleteParadaProgramada(context, id) {
    return window.axios.delete('/api/v2/paradasprogramadas/' + id).then(function (res) {
      return res;
    });
  },
  listParadasProgramadas: function listParadasProgramadas(context, id) {
    return window.axios.get('/api/v2/paradasprogramadas/turno/' + id).then(function (res) {
      context.commit('updateParadasProgramadasList', res);
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  all: [],
  producao: {},
  desempenho: {},
  tag: {},
  tabela: {},
  tabeladesempenho: {}
};

var mutations = {
  fillDataRelatorio: function fillDataRelatorio(state, res) {
    state.producao = res.data;
  },
  fillDataRelatorioTag: function fillDataRelatorioTag(state, res) {
    state.tag = res.data.grafico;
    state.tabela = res.data.tabela;
  },
  fillDataRelatorioPedidosTempo: function fillDataRelatorioPedidosTempo(state, res) {
    state.desempenho = res.data.grafico;
    state.tabeladesempenho = res.data.tabela;
  }
};

var actions = {
  createRelatorioProducao: function createRelatorioProducao(context, data) {
    var qs = __webpack_require__(31);
    data = qs.stringify(data);
    return window.axios.post('/api/v2/relatorios/producao', data).then(function (res) {
      context.commit('fillDataRelatorio', res);
      return res;
    });
  },
  createRelatorioProducaoTag: function createRelatorioProducaoTag(context, data) {
    var qs = __webpack_require__(31);
    data = qs.stringify(data);
    return window.axios.post('/api/v2/relatorios/producao/tag', data).then(function (res) {
      context.commit('fillDataRelatorioTag', res);
      return res;
    });
  },
  createRelatorioProducaoPedidosTempo: function createRelatorioProducaoPedidosTempo(context, data) {
    var qs = __webpack_require__(31);
    data = qs.stringify(data);
    return window.axios.post('/api/v2/relatorios/desempenho', data).then(function (res) {
      context.commit('fillDataRelatorioPedidosTempo', res);
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  all: [],
  atual: {
    id: 0,
    nometurno: 'Não cadastrado',
    horainicio: '--:--',
    horafim: '--:--',
    created_at: '',
    updated_at: ''
  }
};

var mutations = {
  addTurnosList: function addTurnosList(state, res) {
    state.all.push(res.data);
  },
  updateTurnosList: function updateTurnosList(state, res) {
    state.all = res.data;
  },
  updateTurnoAtual: function updateTurnoAtual(state, res) {
    state.atual = res.data;
  }
};

var actions = {
  createTurno: function createTurno(context, data) {
    var qs = __webpack_require__(31);
    data = qs.stringify(data);
    return window.axios.post('/api/v2/turnos', data).then(function (res) {
      context.commit('addTurnosList', res);
      return res;
    });
  },
  updateTurno: function updateTurno(context, data) {
    var id = data.id;
    var qs = __webpack_require__(31);
    var dados = qs.stringify(data.turno);
    return window.axios.put('/api/v2/turnos/' + id, dados).then(function (res) {
      return res;
    });
  },
  deleteTurno: function deleteTurno(context, id) {
    return window.axios.delete('/api/v2/turnos/' + id).then(function (res) {
      return res;
    });
  },
  listTurnos: function listTurnos(context) {
    return window.axios.get('/api/v2/turnos?empresa=' + window.localStorage.getItem('empresa')).then(function (res) {
      context.commit('updateTurnosList', res);
      return res;
    });
  },
  turnoAtual: function turnoAtual(context) {
    return window.axios.get('/api/v2/turnos/data/atual').then(function (res) {
      context.commit('updateTurnoAtual', res);
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  objeto: {
    name: 'Nome',
    email: 'Email',
    cnpj: 'CNPJ',
    projeto: '/',
    token: 'Token'
  }
};

var mutations = {
  updateUserAtual: function updateUserAtual(state, res) {
    state.objeto = res.data;
  },
  fillDataUser: function fillDataUser(state, res) {
    state.objeto.name = res.data.nome;
    state.objeto.email = res.data.email;
    state.objeto.cnpj = res.data.cnpj;
    state.objeto.projeto = res.data.projeto;
    state.objeto.token = res.data.token;
    window.axios.defaults.headers.common['Authorization'] = res.data.token;
    window.localStorage.setItem('token', res.data.token);
    window.localStorage.setItem('empresa', res.data.cnpj);
    window.localStorage.setItem('projeto', res.data.projeto);
  }
};

var actions = {
  updateUser: function updateUser(context, data) {
    var id = data.id;
    var qs = __webpack_require__(31);
    var dados = qs.stringify(data.turno);
    return window.axios.put('/api/v2/turnos/' + id, dados).then(function (res) {
      return res;
    });
  },
  loginUser: function loginUser(context, data) {
    return window.axios.post('/auth/token', data).then(function (res) {
      context.commit('fillDataUser', res);
      return res;
    });
  },
  logoutUser: function logoutUser(context, data) {
    state.objeto.name = null;
    state.objeto.email = null;
    state.objeto.cnpj = null;
    state.objeto.projeto = '';
    state.objeto.token = null;
    window.localStorage.setItem('token', null);
    window.localStorage.setItem('user', null);
    window.localStorage.setItem('empresa', null);
    window.localStorage.setItem('monitores', null);
    window.localStorage.setItem('monitoramento', null);
    window.localStorage.setItem('projeto', null);
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{
      id: 1,
      title: 'Support Team',
      body: 'Why not consider this a test message?',
      createdAt: '17 min ago'
    }],
    notifications: [{
      id: 1,
      title: 'Birthday Reminder',
      body: 'Today is Brians birthday.',
      createdAt: 'just now',
      readAt: null
    }, {
      id: 2,
      title: 'Bank Holiday in London',
      body: 'Our office in London has a bank holiday today. Do not expect them to answer the phone.',
      createdAt: '4 hours ago',
      readAt: null
    }, {
      id: 3,
      title: 'Birthday Reminder',
      body: 'Today is Christians birthday.',
      createdAt: '27 days ago',
      readAt: '2018-08-12 00:00:00'
    }, {
      id: 4,
      title: 'Birthday Reminder',
      body: 'Today is Tanjas birthday.',
      createdAt: '29 days ago',
      readAt: '2018-08-12 00:00:00'
    }, {
      id: 5,
      title: 'Sales Bonus received',
      body: 'You received your monthly sales bonus of 3%. This month you made $2,700 extra!',
      createdAt: '7 hours ago',
      readAt: null
    }],
    tasks: []
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_DashFooter__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_DashFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__layout_DashFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashHeader__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_DashHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hideseek__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hideseek__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    DashFooter: __WEBPACK_IMPORTED_MODULE_1__layout_DashFooter___default.a,
    DashHeader: __WEBPACK_IMPORTED_MODULE_2__layout_DashHeader___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default.a
  },
  data: function data() {
    return {
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].hideLogoOnMobile
      }
    };
  },
  computed: {
    user: function user() {
      return {
        displayName: this.$store.state.Users.objeto.name,
        avatar: 'static/img/stock/user.png',
        roles: [this.$store.state.Users.objeto.email, this.$store.state.Users.objeto.projeto]
      };
    }
  }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(85);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      email: '',
      password: '',
      response: ''
    };
  },
  mounted: function mounted() {
    this.toggleLoading();
  },

  methods: {
    signIn: function signIn() {
      var _this = this;

      this.toggleLoading();
      var qs = __webpack_require__(31);
      if (this.email === '') {
        this.$alertify.alert('This is email');
      } else if (this.password === '') {
        this.$alertify.alert('This is password');
      } else {
        var usuario = qs.stringify({
          email: this.email,
          password: this.password
        });
        this.$store.dispatch('logoutUser');
        this.$store.dispatch('loginUser', usuario).then(function (response) {
          window.localStorage.setItem('token', response.data.token);
          window.localStorage.setItem('monitores', response.data.projeto + '/monitores');
          window.localStorage.setItem('projeto', response.data.projeto);
          __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].project = response.data.projeto;
          _this.$store.commit('SET_TOKEN', response.data.token);
          _this.$store.commit('SET_USER', _this.$store.state.Users.objeto);
          _this.$store.dispatch('listTurnos');
          _this.$store.dispatch('turnoAtual');
          _this.$store.dispatch('listControladores');
          _this.$store.dispatch('updateMonitorDia');
          return _this.$router.push('/');
        }).catch(function (e) {
          _this.$alertify.error('Usuário/Senha inválidos');
        });
      }
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  }
});

/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  data: function data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    };
  },
  mounted: function mounted() {
    this.signOut();
  },

  methods: {
    signOut: function signOut() {
      this.$store.commit('SET_TOKEN', null);
      this.$store.commit('SET_USER', null);
      this.$store.dispatch('logoutUser');
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashFooter',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserMenu__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserMenu__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashHeader',
  components: {
    UserMenu: __WEBPACK_IMPORTED_MODULE_2__UserMenu___default.a
  },
  props: ['user'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['user'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarMenu'
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserMenu',
  props: ['user']
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_VAChart__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_firebaseApp__ = __webpack_require__(447);






var _data = new Date();
var minutos = _data.getMinutes();
if (minutos < 10) {
  minutos = '0' + minutos;
}
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'va-chart': __WEBPACK_IMPORTED_MODULE_1__widgets_VAChart___default.a
  },
  data: function data() {
    return {
      dia: _data.getFullYear() + '-' + this.adicionaZero(_data.getMonth() + 1) + '-' + this.adicionaZero(_data.getDate()),
      hora: _data.getHours(),
      min: minutos,
      detalhes: {
        idDetalhe: 0,
        texto: ''
      },
      paginate: ['dados'],
      dados: [],
      monitores: [],
      monitoresFirebase: null,
      errors: [],
      detalhar: false,
      showDismissibleAlert: false,
      messageAlert: '',
      deuErro: false
    };
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('token')) {
      this.buscarTurnoAtual();
      console.log(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].project);
    } else {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
      this.deuErro = true;
    }
  },

  computed: {
    horaAtual: function horaAtual() {
      var minutosAgora = _data.getMinutes();
      if (minutosAgora < 10) {
        minutosAgora = '0' + minutosAgora;
      }
      return minutosAgora;
    },
    turnoAtual: function turnoAtual() {
      return this.$store.state.Turnos.atual;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  firebase: {
    monitores: __WEBPACK_IMPORTED_MODULE_2__helpers_firebaseApp__["a" /* db */].ref('monitores').child(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].project)
  },
  methods: {
    SegToMili: function SegToMili(temposegundos) {
      return this.$moment.utc(temposegundos * 1000).format('HH:mm:ss');
    },
    ajustarData: function ajustarData(data) {
      var dataAjustada = new Date(data);
      return dataAjustada.toLocaleString();
    },
    adicionaZero: function adicionaZero(numero) {
      if (numero <= 9) {
        return '0' + numero;
      } else {
        return numero;
      }
    },
    buscarMonitorAtual: function buscarMonitorAtual() {
      this.$store.dispatch('updateMonitorDia');
    },
    buscarTurnoAtual: function buscarTurnoAtual() {
      var _this = this;

      this.$store.dispatch('turnoAtual').catch(function (err) {
        if (!_this.deuErro && err.response && err.response.status === 401) {
          _this.showDismissibleAlert = true;
          _this.messageAlert = 'Favor efetuar o login para visualizar os dados';
          _this.deuErro = true;
        } else if (!_this.deuErro && err.response && err.response.status === 404) {
          _this.showDismissibleAlert = true;
          _this.messageAlert = 'Empresa não possui turnos cadastrados nesse horário, favor criar para que possam ser exibidos os dados corretamente';
          _this.deuErro = true;
        } else if (!_this.deuErro && err.response && err.response.status === 405) {
          _this.showDismissibleAlert = true;
          _this.messageAlert = 'Favor contatar o administrador do sistema e informar erro 405 ao buscar o turno atual!';
          _this.deuErro = true;
        }
      });
    },
    detalharMaquina: function detalharMaquina(id, txt, acionamentos) {
      if (id !== this.detalhes.idDetalhe) {
        this.detalhar = true;
        this.detalhes.idDetalhe = id;
      } else {
        this.detalhar = false;
      }
      if (!this.detalhar) {
        this.detalhes.idDetalhe = 0;
      } else {
        console.log(acionamentos);
        this.detalhes.texto = txt;
        this.dados = acionamentos;
      }
    }
  }
});

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_TextReader__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_TextReader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_TextReader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      componentKey: 0,
      text: '',
      programacao: [],
      paginate: ['dados']
    };
  },

  methods: {
    enviarTexto: function enviarTexto(event) {
      var lines = event.split('\r\n');
      var result = [];
      var headers = lines[0].split(';');
      var qtdCabecalho = headers.length;
      for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(';');
        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
        if (currentline.length === qtdCabecalho) {
          result.push(obj);
        }
      }
      this.text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result);
      this.programacao = JSON.parse(this.text);
    },
    forceRender: function forceRender() {
      this.componentKey += 1;
    },
    limparFiles: function limparFiles() {
      this.text = '';
      this.programacao = [];
      this.forceRender();
    }
  },
  mounted: function mounted() {
    this.file1 = null;
  },

  components: {
    TextReader: __WEBPACK_IMPORTED_MODULE_1__widgets_TextReader___default.a
  }
});

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Maquinas',
  mounted: function mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
    }
  },

  computed: {
    legendas: function legendas() {
      return this.$store.state.Legendas.all;
    },
    maquinas: function maquinas() {
      return this.$store.state.Controladores.all;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      tituloModal: '',
      mensagemModal: '',
      statusParaApagar: {},
      showDismissibleAlert: false,
      messageAlert: '',
      results: null,
      maquinaDetalhe: {
        'id': 0,
        'mac': '',
        'nomemaquina': '',
        'created_at': '',
        'updated_at': ''
      },
      funcaoSelecionada: {
        idcontrolador: 0,
        funcao: 'Selecione Função',
        texto: '',
        valor: 0,
        idlegenda: 0
      },
      statusSelecionado: {
        id: 0,
        idcontrolador: 0,
        valorlegenda: 0,
        textolegenda: '',
        isfuncao: false,
        isoperando: false,
        in1: false,
        in2: false,
        in3: false,
        in4: false,
        in5: false,
        in6: false,
        valoralterado: 0
      },
      funcoes: {
        idcontrolador: 0,
        f0: {
          texto: '',
          idlegenda: 0
        },
        f1: {
          texto: '',
          idlegenda: 0
        },
        f2: {
          texto: '',
          idlegenda: 0
        },
        f3: {
          texto: '',
          idlegenda: 0
        },
        f4: {
          texto: '',
          idlegenda: 0
        },
        f5: {
          texto: '',
          idlegenda: 0
        },
        f6: {
          texto: '',
          idlegenda: 0
        }
      },
      errors: [],
      nomemaquinaTemporario: '',
      exibirAtualizarStatus: false,
      exibirAtualizarFuncao: false,
      exibirStatus: false,
      exibirFuncao: false,
      exibirListagem: true,
      exibirNomeMaquina: false
    };
  },

  methods: {
    onValidate: function onValidate(results) {
      console.log(results);
    },

    alterarNomeMaquina: function alterarNomeMaquina(maquina) {
      this.exibirNomeMaquina = true;
      this.maquinaDetalhe = maquina;
      this.nomemaquinaTemporario = maquina.nomemaquina;
    },
    popularFuncoes: function popularFuncoes(listaLegendas) {
      var _this = this;

      listaLegendas.forEach(function (legenda) {
        if (legenda.isfuncao === 1) {
          _this.funcoes.idcontrolador = legenda.idcontrolador;
          switch (legenda.valorlegenda) {
            case 0:
              _this.funcoes.f0.texto = legenda.textolegenda;
              _this.funcoes.f0.idlegenda = legenda.id;
              break;
            case 1:
              _this.funcoes.f1.texto = legenda.textolegenda;
              _this.funcoes.f1.idlegenda = legenda.id;
              break;
            case 2:
              _this.funcoes.f2.texto = legenda.textolegenda;
              _this.funcoes.f2.idlegenda = legenda.id;
              break;
            case 4:
              _this.funcoes.f3.texto = legenda.textolegenda;
              _this.funcoes.f3.idlegenda = legenda.id;
              break;
            case 8:
              _this.funcoes.f4.texto = legenda.textolegenda;
              _this.funcoes.f4.idlegenda = legenda.id;
              break;
            case 16:
              _this.funcoes.f5.texto = legenda.textolegenda;
              _this.funcoes.f5.idlegenda = legenda.id;
              break;
            case 32:
              _this.funcoes.f6.texto = legenda.textolegenda;
              _this.funcoes.f6.idlegenda = legenda.id;
              break;
          }
        }
      });
    },
    novoStatus: function novoStatus() {
      this.exibirAtualizarStatus = true;
      this.exibirFuncao = false;
      this.statusSelecionado.id = 0;
      this.statusSelecionado.idcontrolador = this.maquinaDetalhe.id;
      this.statusSelecionado.valorlegenda = 0;
      this.statusSelecionado.textolegenda = '';
      this.statusSelecionado.isfuncao = false;
      this.statusSelecionado.isoperando = false;
      this.statusSelecionado.in1 = false;
      this.statusSelecionado.in2 = false;
      this.statusSelecionado.in3 = false;
      this.statusSelecionado.in4 = false;
      this.statusSelecionado.in5 = false;
      this.statusSelecionado.in6 = false;
    },
    selecionarStatus: function selecionarStatus(legendaSelecionada) {
      this.exibirAtualizarStatus = true;
      this.exibirFuncao = false;
      this.statusSelecionado.id = legendaSelecionada.id;
      this.statusSelecionado.idcontrolador = legendaSelecionada.idcontrolador;
      this.statusSelecionado.valorlegenda = parseInt(legendaSelecionada.valorlegenda);
      this.statusSelecionado.textolegenda = legendaSelecionada.textolegenda;
      this.statusSelecionado.isfuncao = parseInt(legendaSelecionada.isfuncao);
      this.statusSelecionado.isoperando = parseInt(legendaSelecionada.isoperando);
      this.statusSelecionado.in1 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[7]));
      this.statusSelecionado.in2 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[6]));
      this.statusSelecionado.in3 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[5]));
      this.statusSelecionado.in4 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[4]));
      this.statusSelecionado.in5 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[3]));
      this.statusSelecionado.in6 = Boolean(parseInt(this.intToBinaryString(legendaSelecionada.valorlegenda)[2]));
    },
    selecionarFuncao: function selecionarFuncao(posicaoFuncao) {
      this.exibirAtualizarFuncao = true;
      this.exibirStatus = false;
      this.funcaoSelecionada.idcontrolador = this.funcoes.idcontrolador;
      switch (posicaoFuncao) {
        case 0:
          this.funcaoSelecionada.funcao = 'Não Acionada';
          this.funcaoSelecionada.texto = this.funcoes.f0.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f0.idlegenda;
          this.funcaoSelecionada.valor = 0;
          break;
        case 1:
          this.funcaoSelecionada.funcao = 'Função F1';
          this.funcaoSelecionada.texto = this.funcoes.f1.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f1.idlegenda;
          this.funcaoSelecionada.valor = 1;
          break;
        case 2:
          this.funcaoSelecionada.funcao = 'Função F2';
          this.funcaoSelecionada.texto = this.funcoes.f2.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f2.idlegenda;
          this.funcaoSelecionada.valor = 2;
          break;
        case 3:
          this.funcaoSelecionada.funcao = 'Função F3';
          this.funcaoSelecionada.texto = this.funcoes.f3.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f3.idlegenda;
          this.funcaoSelecionada.valor = 4;
          break;
        case 4:
          this.funcaoSelecionada.funcao = 'Função F4';
          this.funcaoSelecionada.texto = this.funcoes.f4.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f4.idlegenda;
          this.funcaoSelecionada.valor = 8;
          break;
        case 5:
          this.funcaoSelecionada.funcao = 'Função F5';
          this.funcaoSelecionada.texto = this.funcoes.f5.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f5.idlegenda;
          this.funcaoSelecionada.valor = 16;
          break;
        case 6:
          this.funcaoSelecionada.funcao = 'Função F6';
          this.funcaoSelecionada.texto = this.funcoes.f6.texto;
          this.funcaoSelecionada.idlegenda = this.funcoes.f6.idlegenda;
          this.funcaoSelecionada.valor = 32;
          break;
      }
    },
    limparFuncoes: function limparFuncoes() {
      this.limparFuncaoSelecionada();
      this.funcoes = {
        idcontrolador: 0,
        f0: {
          texto: '',
          idlegenda: 0
        },
        f1: {
          texto: '',
          idlegenda: 0
        },
        f2: {
          texto: '',
          idlegenda: 0
        },
        f3: {
          texto: '',
          idlegenda: 0
        },
        f4: {
          texto: '',
          idlegenda: 0
        },
        f5: {
          texto: '',
          idlegenda: 0
        },
        f6: {
          texto: '',
          idlegenda: 0
        }
      };
    },
    limparFuncaoSelecionada: function limparFuncaoSelecionada() {
      this.funcaoSelecionada = {
        idcontrolador: 0,
        funcao: 'Selecione Função',
        texto: '',
        valor: 0,
        idlegenda: 0
      };
    },
    detalharMaquina: function detalharMaquina(maquina) {
      var _this2 = this;

      this.exibirStatus = true;
      this.exibirFuncao = true;
      this.exibirAtualizarStatus = false;
      this.exibirAtualizarFuncao = false;
      this.exibirListagem = false;
      this.limparFuncoes();
      this.maquinaDetalhe = maquina;
      this.$store.dispatch('listLegendas', maquina.id).then(function (response) {
        _this2.popularFuncoes(_this2.legendas);
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    },
    intToBinaryString: function intToBinaryString(number) {
      var result = number.toString(2);
      while (Math.floor(result.length % 8) !== 0) {
        result = '0' + result;
      }
      return result;
    },
    binaryStringToInt: function binaryStringToInt(binario) {
      var result = binario[5] === '1' ? 1 : 0;
      result = result + binario[4] === '1' ? 2 : 0;
      result = result + binario[3] === '1' ? 4 : 0;
      result = result + binario[2] === '1' ? 8 : 0;
      result = result + binario[1] === '1' ? 16 : 0;
      result = result + binario[0] === '1' ? 32 : 0;
      return result;
    },
    atualizarNomeMaquina: function atualizarNomeMaquina() {
      var _this3 = this;

      this.$store.dispatch('updateControlador', {
        id: this.maquinaDetalhe.id,
        controlador: {
          nomemaquina: this.nomemaquinaTemporario,
          mac: this.maquinaDetalhe.mac
        }
      }).then(function (response) {
        _this3.maquinaDetalhe = response.data;
        _this3.$store.dispatch('listControladores');
        _this3.exibirNomeMaquina = false;
      }).catch(function (e) {
        _this3.errors.push(e);
      });
    },
    voltarAtualizarNomeMaquina: function voltarAtualizarNomeMaquina() {
      this.exibirNomeMaquina = false;
    },
    voltarAtualizarFuncao: function voltarAtualizarFuncao() {
      this.detalharMaquina(this.maquinaDetalhe);
    },
    atualizarFuncao: function atualizarFuncao() {
      var _this4 = this;

      if (this.funcaoSelecionada.idlegenda === 0) {
        this.$store.dispatch('createLegenda', {
          textolegenda: this.funcaoSelecionada.texto,
          idcontrolador: this.maquinaDetalhe.id,
          isfuncao: 1,
          isoperando: 0,
          valorlegenda: this.funcaoSelecionada.valor
        }).then(function (response) {
          _this4.detalharMaquina(_this4.maquinaDetalhe);
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this4.showDismissibleAlert = true;
            _this4.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema';
          } else {
            _this4.showDismissibleAlert = true;
            _this4.messageAlert = 'Falha ao alterar a Função. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err;
          }
        });
      } else {
        this.$store.dispatch('updateLegenda', {
          id: this.funcaoSelecionada.idlegenda,
          legenda: {
            textolegenda: this.funcaoSelecionada.texto,
            idcontrolador: this.funcaoSelecionada.idcontrolador,
            isfuncao: 1,
            isoperando: 0,
            valorlegenda: this.funcaoSelecionada.valor
          }
        }).then(function (response) {
          _this4.detalharMaquina(_this4.maquinaDetalhe);
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this4.showDismissibleAlert = true;
            _this4.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema';
          } else {
            _this4.showDismissibleAlert = true;
            _this4.messageAlert = 'Falha ao alterar a Função. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err;
          }
        });
      }
    },
    prepararDeletarStatus: function prepararDeletarStatus(legenda) {
      this.statusParaApagar = legenda;
      this.tituloModal = 'Confirmação de Exclusão de Status';
      this.mensagemModal = 'Tem certeza que deseja excluir o Status? Essa operação não poderá ser desfeita!';
    },
    deletarStatus: function deletarStatus(legenda) {
      var _this5 = this;

      this.$store.dispatch('deleteLegenda', legenda.id).then(function (response) {
        _this5.detalharMaquina(_this5.maquinaDetalhe);
      }).catch(function (err) {
        if (err.response.status === 403) {
          _this5.showDismissibleAlert = true;
          _this5.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema';
        } else {
          _this5.showDismissibleAlert = true;
          _this5.messageAlert = 'Falha ao excluir o Status. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err;
        }
      });
    },
    atualizarStatus: function atualizarStatus() {
      var _this6 = this;

      var valorLegendaAlterada = (this.statusSelecionado.in1 ? 1 : 0) + (this.statusSelecionado.in2 ? 2 : 0) + (this.statusSelecionado.in3 ? 4 : 0) + (this.statusSelecionado.in4 ? 8 : 0) + (this.statusSelecionado.in5 ? 16 : 0) + (this.statusSelecionado.in6 ? 32 : 0);
      if (this.statusSelecionado.id === 0) {
        this.$store.dispatch('createLegenda', {
          textolegenda: this.statusSelecionado.textolegenda,
          idcontrolador: this.statusSelecionado.idcontrolador,
          isfuncao: 0,
          isoperando: this.statusSelecionado.isoperando ? 1 : 0,
          valorlegenda: valorLegendaAlterada
        }).then(function (response) {
          _this6.detalharMaquina(_this6.maquinaDetalhe);
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this6.showDismissibleAlert = true;
            _this6.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema';
          } else {
            _this6.showDismissibleAlert = true;
            _this6.messageAlert = 'Falha ao criar o Status. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err;
          }
        });
      } else {
        this.$store.dispatch('updateLegenda', {
          id: this.statusSelecionado.id,
          legenda: {
            textolegenda: this.statusSelecionado.textolegenda,
            idcontrolador: this.statusSelecionado.idcontrolador,
            isfuncao: 0,
            isoperando: this.statusSelecionado.isoperando ? 1 : 0,
            valorlegenda: valorLegendaAlterada
          }
        }).then(function (response) {
          _this6.detalharMaquina(_this6.maquinaDetalhe);
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this6.showDismissibleAlert = true;
            _this6.messageAlert = 'Você não possui privilégios para executar essa ação. Favor entrar em contato o responsável pelo sistema';
          } else {
            _this6.showDismissibleAlert = true;
            _this6.messageAlert = 'Falha ao alterar o Status. Favor entrar em contato o administrador do sistema informando a mensagem: ' + err;
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosGerais',
  components: {
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('token')) {
      this.$store.dispatch('listTurnos');
    } else {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
    }
  },

  computed: {
    turnos: function turnos() {
      return this.$store.state.Turnos.all;
    },
    monitores: function monitores() {
      return this.$store.state.Controladores.all;
    },
    relatorios: function relatorios() {
      return this.$store.state.Relatorios;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["ptBR"],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveis: false,
        isDadosOutros: false
      },
      exibirGraficoProducao: false,
      exibirGraficoDesempenho: false,
      exibirGraficoTag: false,
      errors: []
    };
  },

  methods: {
    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGraficoProducao = false;
      this.exibirGraficoDesempenho = false;
      this.exibirGraficoTag = false;
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor efetuar o login para buscar o relatório';
      } else if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa';
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um turno para pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.$store.dispatch('createRelatorioProducao', this.pesquisa).then(function (response) {
          _this.exibirGraficoProducao = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
        this.$store.dispatch('createRelatorioProducaoPedidosTempo', this.pesquisa).then(function (response) {
          _this.exibirGraficoDesempenho = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
        this.$store.dispatch('createRelatorioProducaoTag', this.pesquisa).then(function (response) {
          _this.exibirGraficoTag = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosProducao',
  components: {
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
    }
  },

  computed: {
    turnos: function turnos() {
      return this.$store.state.Turnos.all;
    },
    monitores: function monitores() {
      return this.$store.state.Controladores.all;
    },
    relatorios: function relatorios() {
      return this.$store.state.Relatorios;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["ptBR"],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveisComOrdem: false,
        isDadosDisponiveisSemOrdem: false
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGrafico = false;
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor efetuar o login para buscar o relatório';
      } else if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa';
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um turno para pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.$store.dispatch('createRelatorioProducao', this.pesquisa).then(function (response) {
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosProducaoPedidosTempo',
  components: {
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
    }
  },

  computed: {
    turnos: function turnos() {
      return this.$store.state.Turnos.all;
    },
    monitores: function monitores() {
      return this.$store.state.Controladores.all;
    },
    relatorios: function relatorios() {
      return this.$store.state.Relatorios;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["ptBR"],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveis: false,
        isDadosOutros: false
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    ajustarData: function ajustarData(data) {
      var dataAtual = data.split('-');
      return dataAtual[2] + '/' + dataAtual[1];
    },
    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGrafico = false;
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor efetuar o login para buscar o relatório';
      } else if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa';
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um turno para pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        console.log(this.pesquisa);
        this.$store.dispatch('createRelatorioProducaoPedidosTempo', this.pesquisa).then(function (response) {
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosProducaoTag',
  components: {
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
    }
  },

  computed: {
    turnos: function turnos() {
      return this.$store.state.Turnos.all;
    },
    monitores: function monitores() {
      return this.$store.state.Controladores.all;
    },
    relatorios: function relatorios() {
      return this.$store.state.Relatorios;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker_dist_locale__["ptBR"],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveis: false,
        isDadosOutros: false
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGrafico = false;
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor efetuar o login para buscar o relatório';
      } else if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa';
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um turno para pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        console.log(this.pesquisa);
        this.$store.dispatch('createRelatorioProducaoTag', this.pesquisa).then(function (response) {
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_timepicker__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Turnos',
  components: { VueTimepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_timepicker___default.a },
  mounted: function mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true;
      this.messageAlert = 'Favor efetuar o login para visualizar os dados';
    }
  },

  computed: {
    turnos: function turnos() {
      return this.$store.state.Turnos.all;
    },
    paradasprogramadas: function paradasprogramadas() {
      return this.$store.state.ParadasProgramadas.all;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      tituloModal: '',
      mensagemModal: '',
      showDismissibleAlert: false,
      messageAlert: '',
      turnoParaApagar: {},
      paradaParaApagar: {},
      isTurno: true,
      turnoSelecionado: {
        turno: {
          id: 0,
          nometurno: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: '',
          ss: '00'
        },
        horaFim: {
          HH: '',
          mm: '',
          ss: '00'
        },
        paradasprogramadas: []
      },
      paradaSelecionada: {
        parada: {
          id: 0,
          idturno: 0,
          nomeparadaprogramada: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: '',
          ss: '00'
        },
        horaFim: {
          HH: '',
          mm: '',
          ss: '00'
        }
      },
      exibirDetalharTurno: false,
      exibirNovaParada: false,
      errors: [],
      nomemaquinaTemporario: '',
      exibirListagem: true
    };
  },

  methods: {
    buscarHoraMinuto: function buscarHoraMinuto(horaCompleta, isHora) {
      var MinutosIncompletos = horaCompleta.substring(horaCompleta.search(':') + 1, horaCompleta.length);
      if (isHora) {
        return horaCompleta.substring(0, horaCompleta.search(':'));
      } else {
        return MinutosIncompletos.substring(0, MinutosIncompletos.search(':'));
      }
    },
    novoTurno: function novoTurno() {
      if (window.localStorage.getItem('token')) {
        this.limparTurnoSelecionado();
        this.exibirListagem = false;
        this.exibirDetalharTurno = true;
      } else {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor efetuar o login para gravar um novo turno';
      }
    },
    limparTurnoSelecionado: function limparTurnoSelecionado() {
      this.turnoSelecionado = {
        turno: {
          id: 0,
          nometurno: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: ''
        },
        horaFim: {
          HH: '',
          mm: ''
        }
      };
    },
    voltarTurno: function voltarTurno() {
      this.$store.dispatch('listTurnos');
      this.exibirNovaParada = false;
      this.limparParadaSelecionada();
    },
    prepararDeletarTurno: function prepararDeletarTurno(turnoSelecionado) {
      this.isTurno = true;
      this.turnoParaApagar = turnoSelecionado;
      this.tituloModal = 'Confirmação de Exclusão de Turno';
      this.mensagemModal = 'Tem certeza que deseja excluir o turno? Essa operação não poderá ser desfeita!';
    },
    deletarTurno: function deletarTurno(turnoSelecionado) {
      var _this = this;

      this.$store.dispatch('deleteTurno', turnoSelecionado.id).then(function (response) {
        _this.$store.dispatch('listTurnos');
      }).catch(function (err) {
        if (err.response.status === 403) {
          _this.showDismissibleAlert = true;
          _this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema';
        } else {
          _this.showDismissibleAlert = true;
          _this.messageAlert = 'Falha ao apagar o turno. Favor contatar o administrador do sistema informando a mensagem: ' + err;
        }
      });
    },
    selecionarTurno: function selecionarTurno(turno) {
      this.exibirListagem = false;
      this.exibirDetalharTurno = true;
      this.turnoSelecionado.turno = turno;
      this.turnoSelecionado.horaInicio.HH = this.buscarHoraMinuto(turno.horainicio, true);
      this.turnoSelecionado.horaInicio.mm = this.buscarHoraMinuto(turno.horainicio, false);
      this.turnoSelecionado.horaFim.HH = this.buscarHoraMinuto(turno.horafim, true);
      this.turnoSelecionado.horaFim.mm = this.buscarHoraMinuto(turno.horafim, false);
      this.$store.dispatch('listParadasProgramadas', this.turnoSelecionado.turno.id);
    },
    gravarTurno: function gravarTurno() {
      var _this2 = this;

      if (this.turnoSelecionado.turno.id === 0) {
        this.$store.dispatch('createTurno', {
          nometurno: this.turnoSelecionado.turno.nometurno,
          horainicio: this.turnoSelecionado.horaInicio.HH + ':' + this.turnoSelecionado.horaInicio.mm,
          horafim: this.turnoSelecionado.horaFim.HH + ':' + this.turnoSelecionado.horaFim.mm
        }).then(function (response) {
          _this2.turnoSelecionado.turno = response.data;
          _this2.$store.dispatch('listTurnos');
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this2.showDismissibleAlert = true;
            _this2.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema';
          } else {
            _this2.showDismissibleAlert = true;
            _this2.messageAlert = 'Falha ao gravar um novo turno. Favor contatar o administrador do sistema informando a mensagem: ' + err;
          }
        });
      } else {
        var horaInicioAlterada = '';
        var horaFimAlterada = '';
        if (this.turnoSelecionado.horaInicio.mm === 'NaN') {
          horaInicioAlterada = this.turnoSelecionado.turno.horainicio;
        } else {
          horaInicioAlterada = this.turnoSelecionado.horaInicio.HH + ':' + this.turnoSelecionado.horaInicio.mm + ':00';
        }
        if (this.turnoSelecionado.horaFim.mm === 'NaN') {
          horaFimAlterada = this.turnoSelecionado.turno.horafim;
        } else {
          horaFimAlterada = this.turnoSelecionado.horaFim.HH + ':' + this.turnoSelecionado.horaFim.mm + ':00';
        }

        this.$store.dispatch('updateTurno', {
          id: this.turnoSelecionado.turno.id,
          turno: {
            nometurno: this.turnoSelecionado.turno.nometurno,
            horainicio: horaInicioAlterada,
            horafim: horaFimAlterada
          }
        }).then(function (response) {
          _this2.$store.dispatch('listTurnos');
          _this2.mostrarListagem();
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this2.showDismissibleAlert = true;
            _this2.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema';
          } else {
            _this2.showDismissibleAlert = true;
            _this2.messageAlert = 'Falha ao alterar o turno. Favor contatar o administrador do sistema informando a mensagem: ' + err;
          }
        });
      }
    },
    editarParadaProgramada: function editarParadaProgramada(parada) {
      this.paradaSelecionada.parada = parada;
      this.paradaSelecionada.horaInicio.HH = this.buscarHoraMinuto(parada.horainicio, true);
      this.paradaSelecionada.horaInicio.mm = this.buscarHoraMinuto(parada.horainicio, false);
      this.paradaSelecionada.horaFim.HH = this.buscarHoraMinuto(parada.horafim, true);
      this.paradaSelecionada.horaFim.mm = this.buscarHoraMinuto(parada.horafim, false);
      this.exibirNovaParada = true;
    },
    novaParadaProgramada: function novaParadaProgramada() {
      this.exibirNovaParada = true;
    },
    gravarParadaProgramada: function gravarParadaProgramada() {
      var _this3 = this;

      if (this.paradaSelecionada.parada.id === 0) {
        this.$store.dispatch('createParadaProgramada', {
          idturno: this.turnoSelecionado.turno.id,
          nomeparadaprogramada: this.paradaSelecionada.parada.nomeparadaprogramada,
          horainicio: this.paradaSelecionada.horaInicio.HH + ':' + this.paradaSelecionada.horaInicio.mm,
          horafim: this.paradaSelecionada.horaFim.HH + ':' + this.paradaSelecionada.horaFim.mm
        }).then(function (response) {
          _this3.paradaSelecionada.parada = response.data;
          _this3.$store.dispatch('listParadasProgramadas', _this3.turnoSelecionado.turno.id);
          _this3.limparParadaSelecionada();
          _this3.exibirNovaParada = false;
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this3.showDismissibleAlert = true;
            _this3.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema';
          } else {
            _this3.showDismissibleAlert = true;
            _this3.messageAlert = 'Falha ao gravar a Parada Programada. Favor contatar o administrador do sistema informando a mensagem: ' + err;
          }
        });
      } else {
        var horaInicioAlterada = '';
        var horaFimAlterada = '';
        if (this.paradaSelecionada.horaInicio.mm === 'NaN') {
          horaInicioAlterada = this.paradaSelecionada.parada.horainicio;
        } else {
          horaInicioAlterada = this.paradaSelecionada.horaInicio.HH + ':' + this.paradaSelecionada.horaInicio.mm + ':00';
        }
        if (this.paradaSelecionada.horaFim.mm === 'NaN') {
          horaFimAlterada = this.paradaSelecionada.parada.horafim;
        } else {
          horaFimAlterada = this.paradaSelecionada.horaFim.HH + ':' + this.paradaSelecionada.horaFim.mm + ':00';
        }

        this.$store.dispatch('updateParadaProgramada', {
          id: this.paradaSelecionada.parada.id,
          paradaprogramada: {
            idturno: this.paradaSelecionada.parada.idturno,
            nomeparadaprogramada: this.paradaSelecionada.parada.nomeparadaprogramada,
            horainicio: horaInicioAlterada,
            horafim: horaFimAlterada
          }
        }).then(function (response) {
          _this3.$store.dispatch('listParadasProgramadas', _this3.turnoSelecionado.turno.id);
          _this3.limparParadaSelecionada();
          _this3.exibirNovaParada = false;
        }).catch(function (err) {
          if (err.response.status === 403) {
            _this3.showDismissibleAlert = true;
            _this3.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema';
          } else {
            _this3.showDismissibleAlert = true;
            _this3.messageAlert = 'Falha ao alterar a Parada Programada. Favor contatar o administrador do sistema informando a mensagem: ' + err;
          }
        });
      }
    },
    prepararDeletarParada: function prepararDeletarParada(paradaSelecionada) {
      this.isTurno = false;
      this.paradaParaApagar = paradaSelecionada;
      this.tituloModal = 'Confirmação de Exclusão de Parada Programada';
      this.mensagemModal = 'Tem certeza que deseja excluir a Parada Programada? Essa operação não poderá ser desfeita!';
    },
    deletarParada: function deletarParada(paradaSelecionada) {
      var _this4 = this;

      this.$store.dispatch('deleteParadaProgramada', paradaSelecionada.id).then(function (response) {
        _this4.$store.dispatch('listParadasProgramadas', _this4.turnoSelecionado.turno.id);
      }).catch(function (err) {
        if (err.response.status === 403) {
          _this4.showDismissibleAlert = true;
          _this4.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema';
        } else {
          _this4.showDismissibleAlert = true;
          _this4.messageAlert = 'Falha ao apagar a Parada Programada. Favor contatar o administrador do sistema informando a mensagem: ' + err;
        }
      });
    },
    limparParadaSelecionada: function limparParadaSelecionada() {
      this.paradaSelecionada = {
        parada: {
          id: 0,
          idturno: 0,
          nomeparadaprogramada: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: ''
        },
        horaFim: {
          HH: '',
          mm: ''
        }
      };
    },
    mostrarListagem: function mostrarListagem() {
      this.$store.dispatch('listTurnos');
      this.$store.dispatch('clearListParadasProgramadas');
      this.exibirListagem = true;
      this.exibirDetalharTurno = false;
    }
  }
});

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    loadTextFromFile: function loadTextFromFile(ev) {
      var _this = this;

      var file = ev.target.files[0];
      var reader = new FileReader();

      reader.onload = function (e) {
        return _this.$emit('load', e.target.result);
      };
      reader.readAsText(file);
    }
  }
});

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  props: {
    'chart-config': {
      type: Object,
      validator: function validator(value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)');
          return false;
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)');
          return false;
        }
        return true;
      }
    }
  },
  mounted: function mounted() {
    var chartCanvas = this.$el.getContext('2d');
    var chartConfig = this.chartConfig;
    new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(chartCanvas, chartConfig);
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 291,
	"./af.js": 291,
	"./ar": 298,
	"./ar-dz": 292,
	"./ar-dz.js": 292,
	"./ar-kw": 293,
	"./ar-kw.js": 293,
	"./ar-ly": 294,
	"./ar-ly.js": 294,
	"./ar-ma": 295,
	"./ar-ma.js": 295,
	"./ar-sa": 296,
	"./ar-sa.js": 296,
	"./ar-tn": 297,
	"./ar-tn.js": 297,
	"./ar.js": 298,
	"./az": 299,
	"./az.js": 299,
	"./be": 300,
	"./be.js": 300,
	"./bg": 301,
	"./bg.js": 301,
	"./bm": 302,
	"./bm.js": 302,
	"./bn": 303,
	"./bn.js": 303,
	"./bo": 304,
	"./bo.js": 304,
	"./br": 305,
	"./br.js": 305,
	"./bs": 306,
	"./bs.js": 306,
	"./ca": 307,
	"./ca.js": 307,
	"./cs": 308,
	"./cs.js": 308,
	"./cv": 309,
	"./cv.js": 309,
	"./cy": 310,
	"./cy.js": 310,
	"./da": 311,
	"./da.js": 311,
	"./de": 314,
	"./de-at": 312,
	"./de-at.js": 312,
	"./de-ch": 313,
	"./de-ch.js": 313,
	"./de.js": 314,
	"./dv": 315,
	"./dv.js": 315,
	"./el": 316,
	"./el.js": 316,
	"./en-au": 317,
	"./en-au.js": 317,
	"./en-ca": 318,
	"./en-ca.js": 318,
	"./en-gb": 319,
	"./en-gb.js": 319,
	"./en-ie": 320,
	"./en-ie.js": 320,
	"./en-nz": 321,
	"./en-nz.js": 321,
	"./eo": 322,
	"./eo.js": 322,
	"./es": 325,
	"./es-do": 323,
	"./es-do.js": 323,
	"./es-us": 324,
	"./es-us.js": 324,
	"./es.js": 325,
	"./et": 326,
	"./et.js": 326,
	"./eu": 327,
	"./eu.js": 327,
	"./fa": 328,
	"./fa.js": 328,
	"./fi": 329,
	"./fi.js": 329,
	"./fo": 330,
	"./fo.js": 330,
	"./fr": 333,
	"./fr-ca": 331,
	"./fr-ca.js": 331,
	"./fr-ch": 332,
	"./fr-ch.js": 332,
	"./fr.js": 333,
	"./fy": 334,
	"./fy.js": 334,
	"./gd": 335,
	"./gd.js": 335,
	"./gl": 336,
	"./gl.js": 336,
	"./gom-latn": 337,
	"./gom-latn.js": 337,
	"./gu": 338,
	"./gu.js": 338,
	"./he": 339,
	"./he.js": 339,
	"./hi": 340,
	"./hi.js": 340,
	"./hr": 341,
	"./hr.js": 341,
	"./hu": 342,
	"./hu.js": 342,
	"./hy-am": 343,
	"./hy-am.js": 343,
	"./id": 344,
	"./id.js": 344,
	"./is": 345,
	"./is.js": 345,
	"./it": 346,
	"./it.js": 346,
	"./ja": 347,
	"./ja.js": 347,
	"./jv": 348,
	"./jv.js": 348,
	"./ka": 349,
	"./ka.js": 349,
	"./kk": 350,
	"./kk.js": 350,
	"./km": 351,
	"./km.js": 351,
	"./kn": 352,
	"./kn.js": 352,
	"./ko": 353,
	"./ko.js": 353,
	"./ky": 354,
	"./ky.js": 354,
	"./lb": 355,
	"./lb.js": 355,
	"./lo": 356,
	"./lo.js": 356,
	"./lt": 357,
	"./lt.js": 357,
	"./lv": 358,
	"./lv.js": 358,
	"./me": 359,
	"./me.js": 359,
	"./mi": 360,
	"./mi.js": 360,
	"./mk": 361,
	"./mk.js": 361,
	"./ml": 362,
	"./ml.js": 362,
	"./mr": 363,
	"./mr.js": 363,
	"./ms": 365,
	"./ms-my": 364,
	"./ms-my.js": 364,
	"./ms.js": 365,
	"./mt": 366,
	"./mt.js": 366,
	"./my": 367,
	"./my.js": 367,
	"./nb": 368,
	"./nb.js": 368,
	"./ne": 369,
	"./ne.js": 369,
	"./nl": 371,
	"./nl-be": 370,
	"./nl-be.js": 370,
	"./nl.js": 371,
	"./nn": 372,
	"./nn.js": 372,
	"./pa-in": 373,
	"./pa-in.js": 373,
	"./pl": 374,
	"./pl.js": 374,
	"./pt": 376,
	"./pt-br": 375,
	"./pt-br.js": 375,
	"./pt.js": 376,
	"./ro": 377,
	"./ro.js": 377,
	"./ru": 378,
	"./ru.js": 378,
	"./sd": 379,
	"./sd.js": 379,
	"./se": 380,
	"./se.js": 380,
	"./si": 381,
	"./si.js": 381,
	"./sk": 382,
	"./sk.js": 382,
	"./sl": 383,
	"./sl.js": 383,
	"./sq": 384,
	"./sq.js": 384,
	"./sr": 386,
	"./sr-cyrl": 385,
	"./sr-cyrl.js": 385,
	"./sr.js": 386,
	"./ss": 387,
	"./ss.js": 387,
	"./sv": 388,
	"./sv.js": 388,
	"./sw": 389,
	"./sw.js": 389,
	"./ta": 390,
	"./ta.js": 390,
	"./te": 391,
	"./te.js": 391,
	"./tet": 392,
	"./tet.js": 392,
	"./th": 393,
	"./th.js": 393,
	"./tl-ph": 394,
	"./tl-ph.js": 394,
	"./tlh": 395,
	"./tlh.js": 395,
	"./tr": 396,
	"./tr.js": 396,
	"./tzl": 397,
	"./tzl.js": 397,
	"./tzm": 399,
	"./tzm-latn": 398,
	"./tzm-latn.js": 398,
	"./tzm.js": 399,
	"./uk": 400,
	"./uk.js": 400,
	"./ur": 401,
	"./ur.js": 401,
	"./uz": 403,
	"./uz-latn": 402,
	"./uz-latn.js": 402,
	"./uz.js": 403,
	"./vi": 404,
	"./vi.js": 404,
	"./x-pseudo": 405,
	"./x-pseudo.js": 405,
	"./yo": 406,
	"./yo.js": 406,
	"./zh-cn": 407,
	"./zh-cn.js": 407,
	"./zh-hk": 408,
	"./zh-hk.js": 408,
	"./zh-tw": 409,
	"./zh-tw.js": 409
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Principal")])])
}]}

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Áreas")]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/oee"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" OEE")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v("Disponibilidade")])])])], 1)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/maquinas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-android-settings"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Máquinas")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/turnos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-ios-alarm"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Turnos")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-gerais"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Geral")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-producao"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Percentual de Operação")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-producao-tag"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Total Produzido")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/relatorios-producao-Desempenho"
    }
  }, [_c('a', [_c('span', {
    staticClass: "page"
  }, [_vm._v(" Desempenho")])])])], 1)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/importar"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Importar")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/usuario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuário")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Sair")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', [_vm._v("Painel")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa ion-stats-bars"
  }), _vm._v(" "), _c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
}]}

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção/indicador")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.desempenho
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(_vm.ajustarData(index)))])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(2), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.total) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.qtdsetup) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.horasoperando) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.tempoutil) + "\n                      ")])
  })], 2)])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Total Produzido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Num Pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Tempo Produzindo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Turno (h)")])])
}]}

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirmacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "confirmacaoModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content panel-danger"
  }, [_c('div', {
    staticClass: "modal-header panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "confirmacaoModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.tituloModal))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.mensagemModal) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.isTurno) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.deletarTurno(_vm.turnoParaApagar)
      }
    }
  }, [_vm._v("Confirmar")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.deletarParada(_vm.paradaParaApagar)
      }
    }
  }, [_vm._v("Confirmar")])])])])]), _vm._v(" "), _c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirListagem),
      expression: "exibirListagem"
    }],
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Listagem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirDetalharTurno),
      expression: "!exibirDetalharTurno"
    }],
    staticClass: "box-title"
  }, [_vm._v("Listagem dos Turnos Cadastrados")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirDetalharTurno),
      expression: "exibirDetalharTurno"
    }],
    staticClass: "box-title"
  }, [_vm._v("Alterar Dados do Turno")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirDetalharTurno),
      expression: "!exibirDetalharTurno"
    }],
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('tr', {
      key: turno.id
    }, [_c('td', [_vm._v(_vm._s(turno.nometurno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.horainicio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.horafim))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.tempototal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.tempototalparada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(turno.tempoutil))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.selecionarTurno(turno)
        }
      }
    }, [_vm._m(2, true)]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmacaoModal"
      },
      on: {
        "click": function($event) {
          return _vm.prepararDeletarTurno(turno)
        }
      }
    }, [_vm._m(3, true)])])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirListagem),
      expression: "exibirListagem"
    }],
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.novoTurno()
      }
    }
  }, [_vm._v("Novo Turno")])])])])])]), _vm._v(" "), (!_vm.exibirListagem) ? _c('div', {
    staticClass: "row center-block"
  }, [(_vm.turnoSelecionado.turno.id !== 0) ? _c('h2', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mostrarListagem()
      }
    }
  }, [_vm._v("Listagem ")]), _c('small', [_vm._v("Editar Turno")])]) : _vm._e(), _vm._v(" "), (_vm.turnoSelecionado.turno.id === 0) ? _c('h2', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mostrarListagem()
      }
    }
  }, [_vm._v("Listagem ")]), _c('small', [_vm._v("Cadastrar Turno")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirDetalharTurno),
      expression: "exibirDetalharTurno"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNovaParada),
      expression: "!exibirNovaParada"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Turno")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "textoDoTurno"
    }
  }, [_vm._v("Nome do Turno")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.turnoSelecionado.turno.nometurno),
      expression: "turnoSelecionado.turno.nometurno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDoTurno"
    },
    domProps: {
      "value": (_vm.turnoSelecionado.turno.nometurno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.turnoSelecionado.turno, "nometurno", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "inicioDoTurno"
    }
  }, [_vm._v("Início")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.turnoSelecionado.horaInicio),
      callback: function($$v) {
        _vm.$set(_vm.turnoSelecionado, "horaInicio", $$v)
      },
      expression: "turnoSelecionado.horaInicio"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "fimDoTurno"
    }
  }, [_vm._v("Término")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.turnoSelecionado.horaFim),
      callback: function($$v) {
        _vm.$set(_vm.turnoSelecionado, "horaFim", $$v)
      },
      expression: "turnoSelecionado.horaFim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mostrarListagem()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gravarTurno()
      }
    }
  }, [_vm._v("Gravar Turno")])])])])]), _vm._v(" "), (_vm.exibirNovaParada) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', [(_vm.paradaSelecionada.parada.id === 0) ? _c('p', [_c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Nova Parada Programada - Turno " + _vm._s(_vm.turnoSelecionado.turno.nometurno))])])]) : _c('p', [_c('span', [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Editar Parada Programada - Turno " + _vm._s(_vm.turnoSelecionado.turno.nometurno))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "textoDoTurno"
    }
  }, [_vm._v("Nome da Parada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paradaSelecionada.parada.nomeparadaprogramada),
      expression: "paradaSelecionada.parada.nomeparadaprogramada"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDoTurno"
    },
    domProps: {
      "value": (_vm.paradaSelecionada.parada.nomeparadaprogramada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paradaSelecionada.parada, "nomeparadaprogramada", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "inicioDoTurno"
    }
  }, [_vm._v("Início")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.paradaSelecionada.horaInicio),
      callback: function($$v) {
        _vm.$set(_vm.paradaSelecionada, "horaInicio", $$v)
      },
      expression: "paradaSelecionada.horaInicio"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "fimDoTurno"
    }
  }, [_vm._v("Término")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm"
    },
    model: {
      value: (_vm.paradaSelecionada.horaFim),
      callback: function($$v) {
        _vm.$set(_vm.paradaSelecionada, "horaFim", $$v)
      },
      expression: "paradaSelecionada.horaFim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.voltarTurno()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gravarParadaProgramada()
      }
    }
  }, [_vm._v("Gravar Parada")])])])])]) : _vm._e(), _vm._v(" "), (_vm.turnoSelecionado.turno.id !== 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNovaParada),
      expression: "!exibirNovaParada"
    }],
    staticClass: "box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive  col-md-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(5), _vm._v(" "), _vm._l((_vm.paradasprogramadas), function(parada) {
    return _c('tr', {
      key: parada.id
    }, [_c('td', [_vm._v(_vm._s(parada.nomeparadaprogramada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parada.horainicio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parada.horafim))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.editarParadaProgramada(parada)
        }
      }
    }, [_vm._m(6, true)]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmacaoModal"
      },
      on: {
        "click": function($event) {
          return _vm.prepararDeletarParada(parada)
        }
      }
    }, [_vm._m(7, true)])])])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.novaParadaProgramada()
      }
    }
  }, [_vm._v("Nova Parada Programada")])])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Início")]), _vm._v(" "), _c('th', [_vm._v("Término")]), _vm._v(" "), _c('th', [_vm._v("Tempo Total")]), _vm._v(" "), _c('th', [_vm._v("Tempo Paradas")]), _vm._v(" "), _c('th', [_vm._v("Tempo Útil")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar / Detalhar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Apagar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Paradas Programadas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Nome da Parada")]), _vm._v(" "), _c('th', [_vm._v("Hora de Início")]), _vm._v(" "), _c('th', [_vm._v("Hora de Término")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Apagar")])
}]}

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGraficoProducao) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Monitoramentos (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.producao
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoTag) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.tag
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoTag) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(index))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('td', {
      key: index
    }, _vm._l((data), function(valor, campo) {
      return _c('p', {
        key: campo
      }, [_c('strong', [_vm._v(_vm._s(campo) + ": ")]), (campo === 'Total') ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v(_vm._s(valor))]) : _c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(valor))])])
    }), 0)
  }), 0)])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoDesempenho) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.desempenho
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoDesempenho) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(index))])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(4), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.total) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.qtdsetup) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.horasoperando) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.tempoutil) + "\n                      ")])
  })], 2)])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "dados"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosOperando),
      expression: "pesquisa.isDadosOperando"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosOperando) ? _vm._i(_vm.pesquisa.isDadosOperando, null) > -1 : (_vm.pesquisa.isDadosOperando)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosOperando,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosOperando", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosOperando", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosOperando", $$c)
        }
      }
    }
  }), _vm._v("\n                  Operando\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosFuncao),
      expression: "pesquisa.isDadosFuncao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosFuncao) ? _vm._i(_vm.pesquisa.isDadosFuncao, null) > -1 : (_vm.pesquisa.isDadosFuncao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosFuncao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosFuncao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosFuncao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosFuncao", $$c)
        }
      }
    }
  }), _vm._v("\n                  Função\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosOutros),
      expression: "pesquisa.isDadosOutros"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosOutros) ? _vm._i(_vm.pesquisa.isDadosOutros, null) > -1 : (_vm.pesquisa.isDadosOutros)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosOutros,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosOutros", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosOutros", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosOutros", $$c)
        }
      }
    }
  }), _vm._v("\n                  Demais Operações\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosDisponiveis),
      expression: "pesquisa.isDadosDisponiveis"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosDisponiveis) ? _vm._i(_vm.pesquisa.isDadosDisponiveis, null) > -1 : (_vm.pesquisa.isDadosDisponiveis)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosDisponiveis,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosDisponiveis", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosDisponiveis", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosDisponiveis", $$c)
        }
      }
    }
  }), _vm._v("\n                  Disponível\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Total Produzido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Num Pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Tempo Produzindo (h)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Turno (h)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-8 control-label",
    attrs: {
      "for": "dados"
    }
  }, [_vm._v("Tipo de Dados")])])
}]}

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n  Somente arquivos .csv separados por \";\"\n  "), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Você está perdido?")]), _vm._v(" "), _c('h4', [_vm._v("Essa página não existe.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Leve-me para a principal.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Monitoramentos (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.producao
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "dados"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosOperando),
      expression: "pesquisa.isDadosOperando"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosOperando) ? _vm._i(_vm.pesquisa.isDadosOperando, null) > -1 : (_vm.pesquisa.isDadosOperando)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosOperando,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosOperando", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosOperando", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosOperando", $$c)
        }
      }
    }
  }), _vm._v("\n                  Operando\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosFuncao),
      expression: "pesquisa.isDadosFuncao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosFuncao) ? _vm._i(_vm.pesquisa.isDadosFuncao, null) > -1 : (_vm.pesquisa.isDadosFuncao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosFuncao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosFuncao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosFuncao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosFuncao", $$c)
        }
      }
    }
  }), _vm._v("\n                  Função\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosDisponiveisComOrdem),
      expression: "pesquisa.isDadosDisponiveisComOrdem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosDisponiveisComOrdem) ? _vm._i(_vm.pesquisa.isDadosDisponiveisComOrdem, null) > -1 : (_vm.pesquisa.isDadosDisponiveisComOrdem)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosDisponiveisComOrdem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosDisponiveisComOrdem", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosDisponiveisComOrdem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosDisponiveisComOrdem", $$c)
        }
      }
    }
  }), _vm._v("\n                  Disponível Com Ordem\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosDisponiveisSemOrdem),
      expression: "pesquisa.isDadosDisponiveisSemOrdem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosDisponiveisSemOrdem) ? _vm._i(_vm.pesquisa.isDadosDisponiveisSemOrdem, null) > -1 : (_vm.pesquisa.isDadosDisponiveisSemOrdem)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosDisponiveisSemOrdem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosDisponiveisSemOrdem", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosDisponiveisSemOrdem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosDisponiveisSemOrdem", $$c)
        }
      }
    }
  }), _vm._v("\n                  Disponível Sem Ordem\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-8 control-label",
    attrs: {
      "for": "dados"
    }
  }, [_vm._v("Tipo de Dados")])])
}]}

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.tag
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(index))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('td', {
      key: index
    }, _vm._l((data), function(valor, campo) {
      return _c('p', {
        key: campo
      }, [_c('strong', [_vm._v(_vm._s(campo) + ": ")]), (campo === 'Total') ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v(_vm._s(valor))]) : _c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(valor))])])
    }), 0)
  }), 0)])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
}]}

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    key: _vm.componentKey,
    staticClass: "box-body"
  }, [_c('text-reader', {
    on: {
      "load": function($event) {
        return _vm.enviarTexto($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate', {
    staticClass: "paginate-list",
    attrs: {
      "name": "dados",
      "list": _vm.programacao,
      "per": 5
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Empresa")]), _vm._v(" "), _c('th', [_vm._v("Ordem")]), _vm._v(" "), _c('th', [_vm._v("Ítem")]), _vm._v(" "), _c('th', [_vm._v("Sequência")]), _vm._v(" "), _c('th', [_vm._v("Máquina")]), _vm._v(" "), _c('th', [_vm._v("Tempo Previsto")]), _vm._v(" "), _c('th', [_vm._v("Quantidade")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginated('dados')), function(detalhe, index) {
    return _c('tr', {
      key: detalhe.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.empresa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.ordem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.item))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.sequencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.maquina))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.tempo_previsto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.quantidade))])])
  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate-links', {
    attrs: {
      "for": "dados",
      "limit": 5,
      "show-step-links": true,
      "id": "paginacao"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.text !== '') ? [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiles
    }
  }, [_vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.text = ''
      }
    }
  }, [_vm._v("\n              Importar\n            ")])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Importar programação em csv")])])
}]}

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/logo.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('small', {
      key: role
    }, [_vm._v(_vm._s(role))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-flat btn-block",
    attrs: {
      "to": "/logout",
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("\n        Logout\n        ")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")])
}]}

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirmacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "confirmacaoModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content panel-danger"
  }, [_c('div', {
    staticClass: "modal-header panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "confirmacaoModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.tituloModal))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.mensagemModal) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.deletarStatus(_vm.statusParaApagar)
      }
    }
  }, [_vm._v("Confirmar")])])])])]), _vm._v(" "), _c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirListagem),
      expression: "exibirListagem"
    }],
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Listagem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNomeMaquina),
      expression: "!exibirNomeMaquina"
    }],
    staticClass: "box-title"
  }, [_vm._v("Listagem das máquinas instaladas")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirNomeMaquina),
      expression: "exibirNomeMaquina"
    }],
    staticClass: "box-title"
  }, [_vm._v("Alterar Nome da Máquina")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirNomeMaquina),
      expression: "!exibirNomeMaquina"
    }],
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.maquinas), function(maquina) {
    return _c('tr', {
      key: maquina.id
    }, [_c('td', [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.alterarNomeMaquina(maquina)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v("  " + _vm._s(maquina.nomemaquina))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(maquina.mac))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(maquina.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(maquina.updated_at))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.detalharMaquina(maquina)
        }
      }
    }, [_vm._m(2, true)])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirNomeMaquina),
      expression: "exibirNomeMaquina"
    }],
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nomeDaMaquina"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomemaquinaTemporario),
      expression: "nomemaquinaTemporario"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "nomeDaMaquina"
    },
    domProps: {
      "value": (_vm.nomemaquinaTemporario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomemaquinaTemporario = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirNomeMaquina),
      expression: "exibirNomeMaquina"
    }],
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.voltarAtualizarNomeMaquina()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.atualizarNomeMaquina()
      }
    }
  }, [_vm._v("Atualizar os Dados")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirListagem),
      expression: "!exibirListagem"
    }],
    staticClass: "row center-block"
  }, [_c('h2', [_c('a', {
    on: {
      "click": function($event) {
        _vm.exibirListagem = true
      }
    }
  }, [_vm._v("Listagem ")]), _c('small', [_vm._v("Legendas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirFuncao),
      expression: "exibirFuncao"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.maquinaDetalhe.nomemaquina) + " - Funções")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarFuncao),
      expression: "!exibirAtualizarFuncao"
    }],
    staticClass: "box-body no-padding table-responsive  col-md-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(3), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Texto")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f0.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(0)
      }
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f1.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(1)
      }
    }
  }, [_vm._m(5)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f2.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(2)
      }
    }
  }, [_vm._m(6)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f3.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(3)
      }
    }
  }, [_vm._m(7)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f4.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(4)
      }
    }
  }, [_vm._m(8)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f5.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(5)
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.funcoes.f6.texto) + " "), _c('a', {
    staticClass: "btn btn-sm",
    on: {
      "click": function($event) {
        return _vm.selecionarFuncao(6)
      }
    }
  }, [_vm._m(10)])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarFuncao),
      expression: "exibirAtualizarFuncao"
    }],
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "textoDaFuncao"
    }
  }, [_vm._v(_vm._s(_vm.funcaoSelecionada.funcao))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcaoSelecionada.texto),
      expression: "funcaoSelecionada.texto"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDaFuncao"
    },
    domProps: {
      "value": (_vm.funcaoSelecionada.texto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcaoSelecionada, "texto", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarFuncao),
      expression: "exibirAtualizarFuncao"
    }],
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.voltarAtualizarFuncao()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.atualizarFuncao()
      }
    }
  }, [_vm._v("Atualizar Função")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirStatus),
      expression: "exibirStatus"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.maquinaDetalhe.nomemaquina) + " - Status")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarStatus),
      expression: "!exibirAtualizarStatus"
    }],
    staticClass: "box-body no-padding table-responsive  col-md-12"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._m(11), _vm._v(" "), _vm._l((_vm.legendas), function(legenda) {
    return (legenda.isfuncao === 0) ? _c('tr', {
      key: legenda.id
    }, [_c('th', [_vm._v(_vm._s(legenda.textolegenda))]), _vm._v(" "), _c('td', [_c('div', [(legenda.isoperando === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[7] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[6] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[5] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[4] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[3] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', [(_vm.intToBinaryString(legenda.valorlegenda)[2] === '1') ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.selecionarStatus(legenda)
        }
      }
    }, [_vm._m(12, true)]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#confirmacaoModal"
      },
      on: {
        "click": function($event) {
          return _vm.prepararDeletarStatus(legenda)
        }
      }
    }, [_vm._m(13, true)])])])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarStatus),
      expression: "exibirAtualizarStatus"
    }],
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoStatus"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.textolegenda),
      expression: "statusSelecionado.textolegenda"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "textoDoStatus"
    },
    domProps: {
      "value": (_vm.statusSelecionado.textolegenda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.statusSelecionado, "textolegenda", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("Produzindo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.isoperando),
      expression: "statusSelecionado.isoperando"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.isoperando) ? _vm._i(_vm.statusSelecionado.isoperando, null) > -1 : (_vm.statusSelecionado.isoperando)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.isoperando,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "isoperando", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "isoperando", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "isoperando", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in1),
      expression: "statusSelecionado.in1"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in1) ? _vm._i(_vm.statusSelecionado.in1, null) > -1 : (_vm.statusSelecionado.in1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "in1", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "in1", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in1", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in2),
      expression: "statusSelecionado.in2"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in2) ? _vm._i(_vm.statusSelecionado.in2, null) > -1 : (_vm.statusSelecionado.in2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "in2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "in2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in2", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN3")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in3),
      expression: "statusSelecionado.in3"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in3) ? _vm._i(_vm.statusSelecionado.in3, null) > -1 : (_vm.statusSelecionado.in3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "in3", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "in3", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in3", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN4")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in4),
      expression: "statusSelecionado.in4"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in4) ? _vm._i(_vm.statusSelecionado.in4, null) > -1 : (_vm.statusSelecionado.in4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "in4", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "in4", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in4", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN5")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in5),
      expression: "statusSelecionado.in5"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in5) ? _vm._i(_vm.statusSelecionado.in5, null) > -1 : (_vm.statusSelecionado.in5)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in5,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "in5", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "in5", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in5", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": "textoDoProduzindo"
    }
  }, [_vm._v("IN6")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelecionado.in6),
      expression: "statusSelecionado.in6"
    }],
    attrs: {
      "type": "checkbox",
      "id": "textoDoStatus"
    },
    domProps: {
      "checked": Array.isArray(_vm.statusSelecionado.in6) ? _vm._i(_vm.statusSelecionado.in6, null) > -1 : (_vm.statusSelecionado.in6)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.statusSelecionado.in6,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.statusSelecionado, "in6", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.statusSelecionado, "in6", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.statusSelecionado, "in6", $$c)
        }
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarStatus),
      expression: "!exibirAtualizarStatus"
    }],
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exibirListagem = true
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exibirAtualizarStatus),
      expression: "!exibirAtualizarStatus"
    }],
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.novoStatus()
      }
    }
  }, [_vm._v("Novo Status")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarStatus),
      expression: "exibirAtualizarStatus"
    }],
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.voltarAtualizarFuncao()
      }
    }
  }, [_vm._v("Voltar")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exibirAtualizarStatus),
      expression: "exibirAtualizarStatus"
    }],
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.atualizarStatus()
      }
    }
  }, [_vm._v("Atualizar os Dados")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Nome da Máquina")]), _vm._v(" "), _c('th', [_vm._v("Mac Address")]), _vm._v(" "), _c('th', [_vm._v("Instalada")]), _vm._v(" "), _c('th', [_vm._v("Atualizada")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Legendas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("  Editar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Função")]), _vm._v(" "), _c('th', [_vm._v("Não Acionada")]), _vm._v(" "), _c('th', [_vm._v("F1")]), _vm._v(" "), _c('th', [_vm._v("F2")]), _vm._v(" "), _c('th', [_vm._v("F3")]), _vm._v(" "), _c('th', [_vm._v("F4")]), _vm._v(" "), _c('th', [_vm._v("F5")]), _vm._v(" "), _c('th', [_vm._v("F6")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Produzindo")]), _vm._v(" "), _c('th', [_vm._v("IN1")]), _vm._v(" "), _c('th', [_vm._v("IN2")]), _vm._v(" "), _c('th', [_vm._v("IN3")]), _vm._v(" "), _c('th', [_vm._v("IN4")]), _vm._v(" "), _c('th', [_vm._v("IN5")]), _vm._v(" "), _c('th', [_vm._v("IN6")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right badge bg-red"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Apagar")])
}]}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n    "), _c('a', {
    attrs: {
      "href": "http://www.solidtectecnologia.com.br"
    }
  }, [_vm._v("Solidtec Tecnologia")]), _vm._v(".")]), _vm._v(" Todos os direitos reservados.\n")])
},staticRenderFns: []}

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('h3', [_vm._v("Turno atual "), _c('small', [_vm._v(_vm._s(_vm.turnoAtual.nometurno) + " das " + _vm._s(_vm.turnoAtual.horainicio) + " às " + _vm._s(_vm.turnoAtual.horafim) + " com tempo útil de " + _vm._s(_vm.turnoAtual.tempoutil) + "h")])])])]), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4"
    }, [(monitor.atualizado === _vm.dia) ? _c('h4', [_vm._v(_vm._s(monitor.nomemaquina) + " - Uso (%)")]) : _c('h4', [_vm._v(_vm._s(_vm.buscarMonitorAtual()) + "Atualizar Página para - {dia}}")]), _vm._v(" "), _c('h5', [_vm._v("Velocidade: " + _vm._s(monitor.velocidade) + " (cx/h)")]), _vm._v(" "), _c('va-chart', {
      attrs: {
        "chart-config": monitor.chartConfig
      }
    })], 1)
  }), 0)])])]) : _vm._e(), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "box box-success"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(monitor.nomemaquina) + " - Produção")]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_vm._m(1, true), _vm._v(" "), _vm._l((monitor.extraNovo), function(extra, index) {
      return _c('tr', {
        key: extra.id
      }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.SegToMili(extra.duracao)))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "badge bg-green"
      }, [_vm._v(_vm._s(extra.total))])]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "badge bg-red"
      }, [_vm._v(_vm._s(extra.perdas))])])])
    })], 2)])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4",
      on: {
        "click": function($event) {
          return _vm.detalharMaquina(monitor.idcontrolador, monitor.nomemaquina, monitor.Acionamentos)
        }
      }
    }, [(monitor.valorfuncao !== 0) ? _c('div', {
      staticClass: "small-box bg-yellow"
    }, [_c('div', {
      staticClass: "inner"
    }, [(!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(monitor.textofuncao))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(monitor.nomemaquina))]), _vm._v(" "), (!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-text"
    }, [_c('small', [_vm._v(_vm._s(_vm.ajustarData(monitor.updated_at)))])]) : _vm._e(), _vm._v(" "), (_vm.detalhar) ? _c('div', [_c('p', [_vm._v("Operando: " + _vm._s(monitor.horasoperando))]), _vm._v(" "), _c('p', [_vm._v("Em Função: " + _vm._s(monitor.horasfuncao))]), _vm._v(" "), _c('p', [_vm._v("Parado s/ Ordem: " + _vm._s(monitor.horasDisponivelSemOrdem))]), _vm._v(" "), _c('p', [_vm._v("Parado c/ Ordem: " + _vm._s(monitor.horasDisponivelComOrdem))]), _vm._v(" "), _c('p', [_vm._v("Disponível: " + _vm._s(monitor.horasdisponivel))])]) : _vm._e()]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_vm._v("\n          Mais informações "), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e()]) : (monitor.isoperando !== 0) ? _c('div', {
      staticClass: "small-box bg-green"
    }, [_c('div', {
      staticClass: "inner"
    }, [(!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(monitor.textostatus))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(monitor.nomemaquina))]), _vm._v(" "), (!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-text"
    }, [_c('small', [_vm._v(_vm._s(_vm.ajustarData(monitor.updated_at)))])]) : _vm._e(), _vm._v(" "), (_vm.detalhar) ? _c('div', [_c('p', [_vm._v("Operando: " + _vm._s(monitor.horasoperando))]), _vm._v(" "), _c('p', [_vm._v("Em Função: " + _vm._s(monitor.horasfuncao))]), _vm._v(" "), _c('p', [_vm._v("Parado s/ Ordem: " + _vm._s(monitor.horasDisponivelSemOrdem))]), _vm._v(" "), _c('p', [_vm._v("Parado c/ Ordem: " + _vm._s(monitor.horasDisponivelComOrdem))]), _vm._v(" "), _c('p', [_vm._v("Disponível: " + _vm._s(monitor.horasdisponivel))])]) : _vm._e()]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_vm._v("\n          Mais informações "), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e()]) : _c('div', {
      staticClass: "small-box bg-aqua"
    }, [_c('div', {
      staticClass: "inner"
    }, [(!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(monitor.textostatus))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(monitor.nomemaquina))]), _vm._v(" "), (!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-text"
    }, [_c('small', [_vm._v(_vm._s(_vm.ajustarData(monitor.updated_at)))])]) : _vm._e(), _vm._v(" "), (_vm.detalhar) ? _c('div', [_c('p', [_vm._v("Operando: " + _vm._s(monitor.horasoperando))]), _vm._v(" "), _c('p', [_vm._v("Em Função: " + _vm._s(monitor.horasfuncao))]), _vm._v(" "), _c('p', [_vm._v("Parado s/ Ordem: " + _vm._s(monitor.horasDisponivelSemOrdem))]), _vm._v(" "), _c('p', [_vm._v("Parado c/ Ordem: " + _vm._s(monitor.horasDisponivelComOrdem))]), _vm._v(" "), _c('p', [_vm._v("Disponível: " + _vm._s(monitor.horasdisponivel))])]) : _vm._e()]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_vm._v("\n          Mais informações "), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalhar),
      expression: "detalhar"
    }],
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalhar = false
      }
    }
  }, [_vm._v("Voltar")])])])]), _vm._v(" "), (_vm.detalhar) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Registros da Máquina")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.detalhes.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate', {
    staticClass: "paginate-list",
    attrs: {
      "name": "dados",
      "list": _vm.dados,
      "per": 5
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Data Inicio")]), _vm._v(" "), _c('th', [_vm._v("Data Fim")]), _vm._v(" "), _c('th', [_vm._v("Legenda")]), _vm._v(" "), _c('th', [_vm._v("TAG/Cód")]), _vm._v(" "), _c('th', [_vm._v("Extra")]), _vm._v(" "), _c('th', [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginated('dados')), function(detalhe) {
    return _c('tr', {
      key: detalhe.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(detalhe.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.updated_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.textolegenda))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.tag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.extra))]), _vm._v(" "), _c('td', [_c('div', [(detalhe.isinicial === 1) ? _c('span', {
      staticClass: "badge bg-aqua"
    }, [_vm._v("Iniciado")]) : (detalhe.isfuncao === 1) ? _c('span', {
      staticClass: "badge bg-yellow"
    }, [_vm._v("Função")]) : (detalhe.isoperando === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("Operando")]) : _c('span', {
      staticClass: "badge bg-aqua"
    }, [_vm._v("Sem Produção")])])])])
  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate-links', {
    attrs: {
      "for": "dados",
      "limit": 5,
      "show-step-links": true,
      "id": "paginacao"
    }
  })], 1)])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Tag/Cód")]), _vm._v(" "), _c('th', [_vm._v("Duração")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("Qtd")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Perdas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-industry"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-start"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
}]}

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signIn.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Digite seu email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Digite sua senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Controladores.js": 450,
	"./Legendas.js": 451,
	"./Monitoramentos.js": 452,
	"./Monitores.js": 453,
	"./ParadasProgramadas.js": 454,
	"./Relatorios.js": 455,
	"./Turnos.js": 456,
	"./Users.js": 457,
	"./index.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd222021'
});

/***/ })

},[448]);


// WEBPACK FOOTER //
// static/js/app.8d2caaa9a06be2d387c3.js